import React, { useState } from "react";
import styled from "styled-components";
import PretendardText from "../atoms/text/pretendardText";

const SubSideBarItem = (props) => {
  return (
    <StyledSubSideBarItem
      selected={props.selected}
      sub={props.sub}
      style={{
        ...props.style,
      }}
      onClick={props.onClick}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {props.move && (
          <img
            src="/assets/admin/icons/ico_menu.svg"
            style={{
              width: 18,
              height: 18,
              marginRight: !props.sub ? 16 : 0,
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (props.moveHandler) {
                props.moveHandler();
              }
            }}
            alt="이동하기"
          />
        )}
        {props.move && props.reply && (
          <img
            src="/assets/admin/icons/ico_reply.svg"
            style={{
              width: 14,
              height: 14,
              marginLeft: 3,
              marginRight: 8,
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              props.dropdownHandler();
            }}
            alt="서브"
          />
        )}
        {!props.move && props.reply && (
          <img
            src="/assets/admin/icons/ico_reply.svg"
            style={{
              width: 14,
              height: 14,
              marginLeft: 20,
              marginRight: 8,
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              props.dropdownHandler();
            }}
            alt="서브"
          />
        )}
        <SubSideBarItemText selected={props.selected}>
          {props.children}
        </SubSideBarItemText>
      </div>
      {props.move && props.dropdown && (
        <img
          className={props.isRotated ? "rotate" : "rotate-back"}
          src="/assets/admin/icons/ico_select_arrow_down.svg"
          style={{
            width: 18,
            height: 18,
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.stopPropagation();
            props.dropdownHandler();
          }}
          alt="드롭다운"
        />
      )}
      {!props.move && props.dropdown && (
        <img
          className={props.isRotated ? "rotate" : "rotate-back"}
          src="/assets/admin/icons/ico_select_arrow_down.svg"
          style={{
            width: 18,
            height: 18,
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.stopPropagation();
            props.dropdownHandler();
          }}
          alt="드롭다운"
        />
      )}
      {props.icon === "setting" && (
        <img
          src="/assets/admin/icons/ico_setting.svg"
          style={{
            width: 13,
            height: 13,
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.stopPropagation();
            props.settingHandler();
          }}
          alt="설정"
        />
      )}
      {props.icon === "plus" && (
        <img
          src="/assets/admin/icons/ico_plus.svg"
          style={{
            width: 14,
            height: 14,
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.stopPropagation();
            if (props.plusHandler) {
              props.plusHandler();
            } else {
              props.onClick();
            }
          }}
          alt=""
        />
      )}
    </StyledSubSideBarItem>
  );
};

export default SubSideBarItem;

const StyledSubSideBarItem = styled(PretendardText).attrs((props) => {})`
  width: 100%;
  height: fit-content;
  min-height: 39px;
  padding: ${(props) => (props.sub ? "8px 36px" : "8px 16px")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) => (props.selected ? "#313233" : "transparent")};
  cursor: pointer;
`;

const SubSideBarItemText = styled(PretendardText).attrs((props) => {})`
  width: 100%;
  height: fit-content;
  font-weight: ${(props) => (props.selected ? "600" : "400")};
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20.25px;
  color: ${(props) => (props.selected ? "#f3f3f3" : "#aaa")};
`;
